export const GET_ALL_SHAREABLE_DATA_ACTION_TYPE = 'GET_ALL_SHAREABLE_DATA';
export const GET_ALL_SHAREABLE_DATA_SUCCESS_ACTION_TYPE = 'GET_ALL_SHAREABLE_DATA_SUCCESS';

export const UPDATE_SHARE_DATA_SUBMIT_OBJECT = 'SHARE_DATA_SUBMIT';